import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsConfigRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-config',
	path: '/plugins/servlet/project-config/:projectKey/:adminOption',
};
